// extracted by mini-css-extract-plugin
export default {"square":"nJ67hL96siPFdjzuTfA8"};